import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"

const SITE_TAB_TITLE = "Eduardo Figueroa"

/**
 * Gatsby inyecta `Head` dentro de un `<svg>` en el cliente (workaround React 19).
 * Un `<title>` dentro de SVG no es el título del documento, así que la pestaña
 * puede quedar vacía o como la URL. Forzar `document.title` corrige develop y prod.
 */
function syncDocumentTitle(pathname) {
  const path = (pathname || "").replace(/\/$/, "") || "/"
  if (path === "/") {
    document.title = SITE_TAB_TITLE
    return
  }
  if (path.startsWith("/proyectos/")) {
    const h1 = document.querySelector("main h1")
    const pageTitle = h1?.textContent?.trim()
    document.title = pageTitle
      ? `${pageTitle} · ${SITE_TAB_TITLE}`
      : SITE_TAB_TITLE
    return
  }
  document.title = SITE_TAB_TITLE
}

export const onInitialClientRender = () => {
  syncDocumentTitle(window.location.pathname)
}

function prefersReducedMotion() {
  if (typeof window === "undefined") return true
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

function scrollToHash(hash) {
  if (!hash || hash === "#") {
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion() ? "auto" : "smooth",
    })
    return
  }
  const id = hash.replace(/^#/, "")
  if (!id) return
  const el = document.getElementById(id)
  if (!el) return
  el.scrollIntoView({
    behavior: prefersReducedMotion() ? "auto" : "smooth",
    block: "start",
  })
}

/** Navegación cliente (p. ej. Link a /#proyectos): Gatsby no siempre aplica el hash al scroll. */
export const onRouteUpdate = ({ location }) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => syncDocumentTitle(location.pathname))
  })
  if (!location.hash) return
  requestAnimationFrame(() => {
    requestAnimationFrame(() => scrollToHash(location.hash))
  })
}
